import { Box, Table, TableHead, TableRow, TableCell, TableContainer, Paper, TableBody} from '@mui/material'
import React, { useEffect } from 'react'
import { CorporateCodesSelector,fetchAllCodes, CorporateCodeLoadingSelector } from '../../../redux/corporateCodeService'
import { useAppDispatch } from '../../../redux/storeExports'

import CodeListItem from '../atom/CodeListItem'
import LottieLoader from '../atom/LottieLoader'

interface EmailListProps {
  removed?: boolean
}

const EmailList = (props: EmailListProps) => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(fetchAllCodes());
  }, [dispatch]);
  const Codes = CorporateCodesSelector()
  const loading = CorporateCodeLoadingSelector()
 
    return (
     <>
      {loading ? (
        <EmailListLoading />
      ) : (
         <TableContainer component={Paper} sx={{ minWidth: 850 }} aria-label="simple table">
        <Table stickyHeader size="small" >
          <TableHead>
          <TableRow>
          <TableCell></TableCell>
            <TableCell>Titile</TableCell>
            <TableCell align="right">Code</TableCell>
            <TableCell align="right">Owner BUID</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
          <TableBody>
        {Codes.map((employeeObj, index) => (
          <CodeListItem code={employeeObj} key={index} />
        ))}
        </TableBody>
        </Table>
        </TableContainer>
      )}
     </>
    )
}

const EmailListLoading = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
      <LottieLoader />
    </Box>
  )
}


const EmailListSuspense = (props: EmailListProps) => {
  return <EmailList {...props} />
}

export default EmailListSuspense

